module.exports = __webpack_public_path__ + "static/media/ycmsdy.73a6bafd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/ycmsdy.png
// module id = 453
// module chunks = 0